/**
 * localStorage helpers with type safety and error handling.
 *
 * All gateway data is stored in localStorage for now.
 * IndexedDB migration planned for v2 (for better security of private keys).
 */

/** Read and parse a JSON value from localStorage */
export function readJSON<T>(key: string, fallback: T): T {
  try {
    const raw = localStorage.getItem(key);
    if (raw === null) return fallback;
    return JSON.parse(raw) as T;
  } catch {
    return fallback;
  }
}

/** Write a JSON value to localStorage */
export function writeJSON<T>(key: string, value: T): void {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch (e) {
    console.warn(`[storage] Failed to write key "${key}":`, e);
  }
}

/** Read a raw string from localStorage */
export function readString(key: string, fallback: string = ''): string {
  return localStorage.getItem(key) ?? fallback;
}

/** Write a raw string to localStorage */
export function writeString(key: string, value: string): void {
  try {
    localStorage.setItem(key, value);
  } catch (e) {
    console.warn(`[storage] Failed to write key "${key}":`, e);
  }
}

/** Remove a key from localStorage */
export function remove(key: string): void {
  localStorage.removeItem(key);
}
